import _readOnlyError from '@babel/runtime/helpers/readOnlyError';
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { dgInput, required, dgSelect, dgUpload, dgInputSelect, dgTextArea } from 'dg-forms';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { convertToRaw, EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import Swal from 'sweetalert2';
import { DgAccordianItem } from 'dg-utils';
import 'dg-forms/dist/index.css';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WYSIWUG_Editor = /*#__PURE__*/function (_Component) {
  _inherits(WYSIWUG_Editor, _Component);

  var _super = _createSuper(WYSIWUG_Editor);

  function WYSIWUG_Editor(props) {
    var _this;

    _classCallCheck(this, WYSIWUG_Editor);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onEditorStateChange", function (editorState) {
      var _this$props$input = _this.props.input,
          onChange = _this$props$input.onChange,
          value = _this$props$input.value;
      var newValue = draftToHtml(convertToRaw(_this.state.editorState.getCurrentContent()));
      console.log("Value :: ".concat(value));
      console.log("NewValue :: ".concat(newValue));

      if (value !== newValue) {
        onChange(newValue);
      }

      _this.setState({
        editorState: editorState
      });
    });

    _this.state = {
      editorState: EditorState.createEmpty(),
      time: 0,
      start: 0
    };

    _this.props.input.onChange(draftToHtml(convertToRaw(_this.state.editorState.getCurrentContent())));

    _this.imageUpload = _this.imageUpload.bind(_assertThisInitialized(_this));
    _this.startTimer = _this.startTimer.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WYSIWUG_Editor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimer();

      if (this.props.clearForm) {
        var contentBlock = '';

        if (this.props.post) {
          contentBlock = htmlToDraft(this.props.post.wysiwyg || '');
        }

        if (this.props.product) {
          var product = this.props.product && this.props.product.body_html && this.props.product.body_html !== '' ? this.props.product.body_html : '';
          contentBlock = htmlToDraft(product);
        }

        console.log(contentBlock);

        if (contentBlock) {
          var contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          var editorState = EditorState.createWithContent(contentState);
          console.log(editorState);
          this.setState({
            editorState: editorState
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.time === 100) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      document.getElementsByClassName('public-DraftEditor-content')[0].focus();
      console.log('focused');
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;

      this.timer = setInterval(function () {
        return _this2.setState({
          time: _this2.state.time + 10
        });
      }, 10);
    }
  }, {
    key: "imageUpload",
    value: function () {
      var _imageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        var form, files;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(file);
                form = new FormData();
                form.append('blog_image', file);
                _context.next = 5;
                return this.props.uploadImage(form)["catch"](function (res) {
                  Swal.fire('Error', res.message, 'error');
                });

              case 5:
                files = _context.sent;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  resolve({
                    data: {
                      link: files.files[0].url
                    }
                  });
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function imageUpload(_x) {
        return _imageUpload.apply(this, arguments);
      }

      return imageUpload;
    }()
  }, {
    key: "render",
    value: function render() {
      var editorState = this.state.editorState;
      return /*#__PURE__*/React.createElement("div", {
        className: "WYSIWUG_Editor"
      }, /*#__PURE__*/React.createElement(Editor, {
        editorState: editorState,
        wrapperClassName: "wrapper-class",
        editorClassName: "editor-class",
        toolbarClassName: "toolbar-class",
        onEditorStateChange: this.onEditorStateChange,
        toolbar: {
          image: {
            previewImage: true,
            uploadEnabled: true,
            uploadCallback: this.imageUpload
          }
        }
      }));
    }
  }]);

  return WYSIWUG_Editor;
}(Component);

var formatSlug = function formatSlug(value, name) {
  console.log('formatSlug', value, name);

  if (value && value !== '') {
    value = value.toLowerCase();
    value = value.replaceAll(' ', '-');
    value = value.replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''); // Remove All Special Characters
  }

  return value;
};

var formatDate = function formatDate(value, name) {
  console.log('formatDate', value, name);

  if (value && value !== '') {
    value = new Date(value).toISOString().split('.')[0];
  }

  return value;
};

var Blog_Form = function Blog_Form(props) {
  var handleSubmit = props.handleSubmit;
      props.submitting;
      var clearForm = props.clearForm,
      post = props.post,
      blog = props.blog,
      header_image = props.header_image,
      uploadImage = props.uploadImage,
      tags = props.tags,
      headerImageAccept = props.headerImageAccept;
  var renderTags = [];

  if (tags && tags.length > 0) {
    tags.map(function (value, index) {
    }), _readOnlyError("renderTags");
  }

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: "BlogForm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-row"
  }, /*#__PURE__*/React.createElement(Field, {
    disabled: blog.isPostLoading,
    name: "title",
    type: "text",
    component: dgInput,
    containerClass: "field-group title",
    placeholder: "My New Post",
    label: "Post Title",
    labelClass: "required",
    validate: [required]
  }), /*#__PURE__*/React.createElement(Field, {
    disabled: blog.isPostLoading,
    labelClass: "required",
    label: "Status",
    name: "status",
    containerClass: "field-group status",
    component: dgSelect,
    validate: [required],
    defaultValue: 'Draft'
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Please Select"), /*#__PURE__*/React.createElement("option", {
    value: "Draft"
  }, "Draft"), /*#__PURE__*/React.createElement("option", {
    value: "Published"
  }, "Published"))), /*#__PURE__*/React.createElement("div", {
    className: "container-row"
  }, header_image ? /*#__PURE__*/React.createElement("div", {
    className: "image-preview"
  }, /*#__PURE__*/React.createElement("img", {
    className: "img",
    src: header_image,
    alt: "header img preview"
  })) : '', /*#__PURE__*/React.createElement(Field, {
    label: "Article Image",
    labelClass: "",
    disabled: blog.isPostLoading,
    multiple: false,
    accept: headerImageAccept || '.png, .jpg, .jpeg',
    name: "header_image",
    component: dgUpload,
    validate: []
  }), /*#__PURE__*/React.createElement(Field, {
    name: "tag",
    type: "text",
    component: dgInputSelect,
    containerClass: "field-group tag",
    placeholder: "Post Tag",
    disabled: blog.isPostLoading,
    label: "Post Tag (default to General)",
    labelClass: "required",
    validate: [required],
    defaultValue: ""
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Please Select"), /*#__PURE__*/React.createElement("option", {
    value: "General"
  }, "General"), renderTags)), /*#__PURE__*/React.createElement("div", {
    className: "container-row"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "summary",
    component: dgTextArea,
    label: "Article Summary",
    disabled: blog.isPostLoading,
    labelClass: "required",
    validate: [required]
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-row"
  }, /*#__PURE__*/React.createElement(DgAccordianItem, {
    isExpanded: true,
    title: /*#__PURE__*/React.createElement("h3", null, "Additional Fields"),
    component: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      disabled: blog.isPostLoading,
      name: "createdAt",
      type: "datetime-local",
      component: dgInput,
      label: "Created At",
      labelClass: "",
      format: formatDate,
      validate: []
    }), /*#__PURE__*/React.createElement(Field, {
      disabled: blog.isPostLoading,
      name: "slug",
      type: "text",
      component: dgInput,
      label: "Slug",
      labelClass: "",
      format: formatSlug,
      validate: []
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "redux-blogs-btn-primary",
    disabled: blog.isPostLoading
  }, "Save"))), /*#__PURE__*/React.createElement("div", {
    className: "wysiwyg-wrapper"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "wysiwyg",
    uploadImage: uploadImage,
    component: WYSIWUG_Editor,
    clearForm: clearForm,
    post: post
  })));
};

Blog_Form = reduxForm({
  form: 'Blog_Form'
})(Blog_Form);
var BlogForm = Blog_Form;

export { BlogForm as B, WYSIWUG_Editor as W };
